import React from 'react';
import styled from 'styled-components';

import { Paper, Typography } from '@material-ui/core';

import ProductImageScalebloc from '../../assets/scalebloc.png';
import ProductImageScalecube from '../../assets/scalecube.png';
import IconArrow from '../../assets/icon-arrow.svg';

const Root = styled(Paper)`
	height: 100%;
	padding: 20px;
	cursor: pointer;

	.tile-head {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 20px;

		h5 {
			font-size: 16px;
			font-weight: bold;
		}

		img {
			width: 30px;
		}
	}

	.tile-content {
		img {
			max-width: 100%;
			height: auto;
		}
	}
`;

const TileStorageCab = ({ toggleModal, isStoragePark }) => (
	<Root onClick={toggleModal}>
		<div className="tile-head">
			<Typography variant="h5">
				{isStoragePark ? 'scalecube' : 'scalebloc'}
			</Typography>
			<img src={IconArrow} alt="" />
		</div>
		<div className="tile-content">
			{isStoragePark ? (
				<img src={ProductImageScalecube} alt="scalecube" />
			) : (
				<img src={ProductImageScalebloc} alt="scalebloc" />
			)}
		</div>
	</Root>
);

export default TileStorageCab;
